import { useParams } from 'react-router'

// Reads a param the matched route always provides (e.g. :urlToken in /verify/:urlToken).
export function useRouteParam(name: string): string {
  const value = useParams()[name]
  if (value === undefined) {
    throw new Error(`Route is missing the :${name} param`)
  }
  return value
}
